import { render, staticRenderFns } from "./TicketComment.vue?vue&type=template&id=0413b9a4&"
import script from "./TicketComment.vue?vue&type=script&lang=js&"
export * from "./TicketComment.vue?vue&type=script&lang=js&"
import style0 from "./TicketComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports